"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Overview = function Overview(_ref) {
  var align = _ref.align,
      children = _ref.children,
      title = _ref.title,
      description = _ref.description,
      rest = _objectWithoutProperties(_ref, ["align", "children", "title", "description"]);

  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    component: "section",
    textAlign: align
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, rest, title && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h2"
  }, title), description && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    component: "p",
    variant: "subtitle1"
  }, description))), children);
};

Overview.propTypes = {
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array, _propTypes["default"].node]),
  align: _propTypes["default"].oneOf(['left', 'right', 'center'])
};
Overview.defaultProps = {
  title: '',
  description: '',
  align: 'left',
  children: null
};
var _default = Overview;
exports["default"] = _default;